import React from "react";
import "./About.css";
import Icon from "../Icon";
import {
  faBuildingColumns,
  faCertificate,
  faGraduationCap,
  faTeeth,
  faUserDoctor,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import SEO from "../SEO";

const drAlina = () => {
  return (
    <article>
      <p>
        Dr. Alina, a Brooklyn native, earned her Doctorate from the NYU
        College of Dentistry. She further advanced her training by completing
        the Advanced Education in General Dentistry program at NYU Langone.
        Known for her exceptional patient care, Dr. Alina has earned great
        admiration from her patients.
      </p>
      <p>
        Outside of work, Dr. Alina enjoys spending time with her family and her
        two young children, who keep her very busy. She is a proud member of the
        American Dental Association (ADA), the Second District Dental Society,
        and the New York State Dental Association (NYSDA).
      </p>
      <p>
        Dr. Alina's goal is to help her patients feel comfortable and leave with
        confidence. Having grown up with a dental phobia herself, she
        understands the importance of educating her patients every step of the
        way.
      </p>
    </article>
  );
};

const CredentialsList = ({ credentials }) => (
  <ul className="credentials-list" aria-label="Professional credentials">
    {credentials.map((cred, index) => (
      <li key={index}>
        <Icon icon={cred.icon} />
        <span>{cred.text}</span>
      </li>
    ))}
  </ul>
);

const rdhInna = () => {
  return (
    <article>
      <p>
      Inna provides high-quality dental hygiene care to her patients. She
      supports their oral health through regular cleanings and checkups while
      educating them on how to maintain a healthy, beautiful smile. 
      </p>
      <p>
      Inna strives to ensure that every patient feels comfortable in the chair and confident
      in the treatment they receive. Alongside providing expert dental cleaning
      services, she is always happy to answer questions regarding daily dental
      hygiene. 
      </p>
      <p>
      A graduate of the City University of New York, Inna has a deep
      passion for learning. She actively pursues continuing education to stay
      current in her field, completing advanced training in scaling and root
      planing, local anesthesia, nitrous oxide, radiography, first aid,
      nutrition, and CPR.
      </p>
      <p>

      She makes it a priority to ensure each patient’s visit
      is a positive experience by combining a gentle demeanor with thorough
      clinical skill. Ultimately, she loves witnessing the positive physical and
      emotional transformations that occur when a patient achieves optimal
      dental health.
      </p>

    </article>
  );
};

const StaffSection = ({ doctor }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section
      className="doctor-container"
      aria-labelledby={`doctor-${doctor.name.split(" ")[0]}`}
    >
      <div className="doctor-profile">
        <div className="profile-image-overlay">
          <img
            src={ doctor.image}
            alt={`Portrait of ${doctor.name}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
          <div className="profile-details">
            <h2 id={`doctor-${doctor.name.split(" ")[0]}`}>{doctor.name}</h2>
            <p>{doctor.title}</p>
          </div>
        </div>
      </div>

      <div className="doctor-about">
        {doctor.description}
        {doctor.credentials && (
          <CredentialsList credentials={doctor.credentials} />
        )}
        {doctor.specialties && (
          <div className="doctor-specialties">
            <h3>Areas of Focus</h3>
            <div className="specialty-tags">
              {doctor.specialties.map((specialty, index) => (
                <span key={index} className="specialty-tag">
                  {specialty}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

const About = () => {
  const staff = [
    {
      name: "Alina Draganchyuk Aga, DDS",
      title: "General Dentist & Cosmetic Dentist",
      description: drAlina(),
      image: "/imgs/dr-alina.webp",
      credentials: [
        {
          icon: faGraduationCap,
          text: "Doctor of Dental Surgery (DDS), NYU College of Dentistry",
        },
        {
          icon: faCertificate,
          text: "Advanced Education in General Dentistry, NYU Langone",
        },
        {
          icon: faUserDoctor,
          text: "American Dental Association (ADA) Member",
        },
        {
          icon: faBuildingColumns,
          text: "New York State Dental Association (NYSDA) Member",
        },
        {
          icon: faUsers,
          text: "Second District Dental Society Member",
        },
      ],
      specialties: [
        "Cosmetic Dentistry",
        "Preventive Care",
        "Restorative Dentistry",
        "Anxiety-Free Dentistry",
        "Family Dentistry",
      ],
    },
    {
      name: "Inna, RDH",
      title: "Registered Dental Hygienist",
      description: rdhInna(),
      image: "/imgs/rdh-inna.webp",
      credentials: [
        {
          icon: faGraduationCap,
          text: "RDH, Graduate of the City University of New York",
        },
        {
          icon: faCertificate,
          text: "Specialized Training in Comfort & Pain Management",
        },
        {
          icon: faTeeth,
          text: "Expertise in Deep Cleaning & Periodontal Health",
        },
        {
          icon: faCertificate,
          text: "Certified in Emergency First Aid & CPR",
        },
      ],
      specialties: [
        "Preventive Care",
        "Periodontal Therapy",
        "Patient Education",
        "Nutritional Counseling",
        "Anxiety-Free Care",
        "Pain Management",
      ],
    },
  ];

  return (
    <main className="center-container fade-in">
      <SEO
        title="Dr. Alina Aga, DDS, Bensonhurst Dentist"
        description="Meet Dr. Alina Aga, DDS, an NYU-trained cosmetic and general dentist in Bensonhurst, Brooklyn. Gentle care for anxious patients. English, Russian & Ukrainian spoken."
        canonical="/about"
      />
      <header className="about-header">
        <h1>Meet Our Team</h1>
        <p>Our team speaks English, Russian, and Ukrainian.</p>
      </header>
      {staff.map((doctor, index) => (
        <StaffSection key={index} doctor={doctor} />
      ))}
    </main>
  );
};

export default About;
